const langData = {
    en: {
        signUpToday: `Sign up today`,
        letsChangeTravel: `Let's change travel together`,
        realPeopleBehindIntro2: `who are helping us drive change in the travel
        industry.`,
        realPeopleBehindIntro: `The only way the Konnect community is possible
        is thorough a diverse group of amazing locals
        and travelers like`,
        realPeopleBehind: 'The real people behind Konnect',
        meetOurKreators: 'Meet our Kreators',
        guest: 'Guest',
        home: 'Home',
        kreatorPortal: 'Kreator Portal',
        howItWorks: 'How it works',
        getItFor: 'Get it for',
        exploreMore: 'Explore more',
        rtl: '',
        lang: 'English',
        lang_iso: 'en',
        messages: {
            hello: 'Hello',
            welcome: 'Welcome',
            welcomeBack: 'Welcome Back'
        },

        navbar: {
            search: 'Find your experience'
        },

        menu: {
            messages: {
                title: 'Messages',
                icon: 'Grid'
            },
            myPurchases: {
                title: 'My Purchases',
                icon: 'DollarSign'
            },
            myFavourites: {
                title: 'My Favourites',
                icon: 'User'
            },
            profile: {
                title: 'Profile',
                icon: 'User'
            },
            helpCenter: {
                title: 'Konnect Academy',
                icon: 'HelpCircle'
            },
            signout: {
                title: 'Log out',
                icon: 'LogOut'
            },
            signup: {
                title: 'Sign up',
                icon: 'LogOut'
            },
            signin: {
                title: 'Sign in',
                icon: 'LogOut'
            },
            becomeKreator: {
                title: 'Become a Kreator',
                icon: 'LogOut'
            }
        },
        sections: {
            newThisMonth: {
                title: 'Latest experiences',
                subTitle: 'Fresh new adventures from around the globe'
            },
            wanderByDestination: {
                title: 'Explore by destination',
                subTitle: 'Every corner of the world is up for grabs.'
            },
            wanderByInterest: {
                title: 'Explore by interest',
                subTitle: 'A glimpse of what other wanderers are looking for'
            },
            curatedCollections: {
                title: 'Curated collections',
                subTitle: 'Hand picked by our staff'
            },
            trendingThisWeek: {
                title: 'Trending this week',
                subTitle: 'Check what other wanderers are looking for'
            },
            exploreEverything: {
                title: 'Explore all experiences',
                subTitle: 'Browse everything the world has to offer'
            },
            exploreByKreator: {
                title: 'Explore by Kreator',
                subTitle: 'Browse all experiences by your favorite Kreators'
            }
        },
        components: {
            bestTimeToGo: {
                // Full Months
                UI_DATE_MONTH_FULL_1: 'January',
                UI_DATE_MONTH_FULL_2: 'February',
                UI_DATE_MONTH_FULL_3: 'March',
                UI_DATE_MONTH_FULL_4: 'April',
                UI_DATE_MONTH_FULL_5: 'May',
                UI_DATE_MONTH_FULL_6: 'June',
                UI_DATE_MONTH_FULL_7: 'July',
                UI_DATE_MONTH_FULL_8: 'August',
                UI_DATE_MONTH_FULL_9: 'September',
                UI_DATE_MONTH_FULL_10: 'October',
                UI_DATE_MONTH_FULL_11: 'November',
                UI_DATE_MONTH_FULL_12: 'December',

                // 3 Letter or short months
                UI_DATE_MONTH_SHORT_1: 'Jan',
                UI_DATE_MONTH_SHORT_2: 'Feb',
                UI_DATE_MONTH_SHORT_3: 'Mar',
                UI_DATE_MONTH_SHORT_4: 'Apr',
                UI_DATE_MONTH_SHORT_5: 'May',
                UI_DATE_MONTH_SHORT_6: 'Jun',
                UI_DATE_MONTH_SHORT_7: 'Jul',
                UI_DATE_MONTH_SHORT_8: 'Aug',
                UI_DATE_MONTH_SHORT_9: 'Sep',
                UI_DATE_MONTH_SHORT_10: 'Oct',
                UI_DATE_MONTH_SHORT_11: 'Nov',
                UI_DATE_MONTH_SHORT_12: 'Dec'
            },
            hotelInfo: {
                // Accommodation refs

                ACC_HOTEL: 'Hotel',
                ACC_MOTEL: 'Motel',
                ACC_APARTMENT: 'Apartment',
                ACC_CHALET: 'Chalet',
                ACC_COTTAGE: 'Cottage',
                ACC_LOG_CABIN: 'Log Cabin',
                ACC_CAMPING_TENT: 'Camping Site',
                ACC_CAMPING_SITE: 'Camping Site',
                ACC_TEPEE: 'Tepee',
                ACC_RESORT: 'Resort',
                ACC_BED_N_BREAKFAST: 'Bed and Breakfast',
                ACC_APART_HOTEL: 'Apart Hotel',
                ACC_GUEST_HOUSE: 'Guest House',
                ACC_YOUTH_HOSTEL: 'Youth Hostel',
                ACC_BOAT: 'Boat',
                ACC_CAMPER: 'Camper',
                ACC_YURT: 'Yurt',
                ACC_TREEHOUSE: 'Treehouse',

                ACC_STAR1: '1 Star',
                ACC_STAR2: '2 Stars',
                ACC_STAR3: '3 Stars',
                ACC_STAR4: '4 Stars',
                ACC_STAR5: '5 Stars',
                ACC_NA: 'Rating Not available',
                ACC_BOUTIQUE: 'Boutique Hotel',

                ACC_LUXURIOUS: 'Lurxurious',
                ACC_UPSCALE: 'Upscale',
                ACC_HOMEY: 'Homey',
                ACC_COSEY: 'Cosey',
                ACC_HIP: 'Hip / Trendy',
                ACC_FAMILY: 'Family Friendly',
                ACC_CORPORATE: 'Corporate'
            }
        },
        errors: {
            'Auth.form.error.invalid': 'Invalid email or password',
            'Auth.form.error.email.taken':
                'The Email or username are already taken',
            DEFAULTERROR: "Oops. Something went wrong. That's all we know",
            NETWORKERROR: 'The server is bugging. Sorry about that',
            LOGIN_SUCCESS: 'Hello Kreator!',
            REGISTER_SUCCESS: 'Welcome Kreator!',
            PROFILE_SUCCESS: 'Profile Saved',
            FORBIDDEN: "Hmm...it seems you're not allowed to make that request",
            REJECTED: 'Submission rejected',
            NOTFOUND: 'Submission page not found'
        }
    },

    ar: {
        signUpToday: `انضم اليوم`,
        letsChangeTravel: `لنغير تاريخ السفر معاً`,
        realPeopleBehindIntro2: `الذين يساعدون على عمل تغيير حقيقي في صناعة السفر.`,
        realPeopleBehindIntro: `السبيل الوحيد لوجود مجتمع Konnect هو عن طريق 
        فريق متنوع ورائع من المسافرين والمرشدين مثل `,
        realPeopleBehind: 'الأبطال الحقيقيون وراء Konnect',
        meetOurKreators: 'قابل صناع المحتوى',
        guest: 'زائر',
        home: 'الرئيسية',
        kreatorPortal: 'بوابة صناع المحتوى',
        howItWorks: 'طريقة العمل',
        getItFor: 'احصل عليها مقابل',
        exploreMore: 'استكشف المزيد',
        rtl: true,
        lang: 'Arabic',
        lang_iso: 'ar',
        messages: {
            hello: 'ًأهلا',
            welcome: 'مرحباً',
            welcomeBack: 'مرحباً بعودتك'
        },

        navbar: {
            search: 'ابحث عن تجربتك'
        },

        menu: {
            messages: {
                title: 'الرسائل',
                icon: 'Grid'
            },
            myPurchases: {
                title: 'المقتنيات',
                icon: 'DollarSign'
            },
            myFavourites: {
                title: 'التفضيلات',
                icon: 'User'
            },
            profile: {
                title: 'الملف الشخصي',
                icon: 'User'
            },
            helpCenter: {
                title: 'الأكاديمية',
                icon: 'HelpCircle'
            },
            signout: {
                title: 'تسجيل الخروج',
                icon: 'LogOut'
            },
            signup: {
                title: 'الاشتراك',
                icon: 'LogOut'
            },
            signin: {
                title: 'تسجيل الدخول',
                icon: 'LogOut'
            },
            becomeKreator: {
                title: 'اصبح صانع محتوى',
                icon: 'LogOut'
            }
        },
        sections: {
            newThisMonth: {
                title: 'آخر التجارب',
                subTitle: 'تجارب جديدة من جميع أنحاء العالم'
            },
            wanderByDestination: {
                title: 'استكشف بالمكان',
                subTitle: 'من كل أنحاء العالم بين يديك'
            },
            wanderByInterest: {
                title: 'استكشف بالإهتمام',
                subTitle: 'كل ما يبحث عنه الآخرون أمامك'
            },
            curatedCollections: {
                title: 'المجموعة الخاصة',
                subTitle: 'انتقاء خاص عن طريق فريق العمل'
            },
            trendingThisWeek: {
                title: 'الأشهر هذا الأسبوع',
                subTitle: 'آخر ما يبحث عنه المستخدمون'
            },
            exploreEverything: {
                title: 'استكشف كل التجارب',
                subTitle: 'العالم لديه الكثير لك لكي تكتشفه'
            },
            exploreByKreator: {
                title: 'استكشف تجارب صنّاع محددين',
                subTitle: 'استكشاف التجارب حسب صنّاع محتوى مفضلين لديك'
            }
        },
        components: {
            bestTimeToGo: {
                // Full Months
                UI_DATE_MONTH_FULL_1: 'يناير',
                UI_DATE_MONTH_FULL_2: 'فبراير',
                UI_DATE_MONTH_FULL_3: 'مارس',
                UI_DATE_MONTH_FULL_4: 'أبريل',
                UI_DATE_MONTH_FULL_5: 'مايو',
                UI_DATE_MONTH_FULL_6: 'يونيو',
                UI_DATE_MONTH_FULL_7: 'يوليو',
                UI_DATE_MONTH_FULL_8: 'أغسطس',
                UI_DATE_MONTH_FULL_9: 'سبتمبر',
                UI_DATE_MONTH_FULL_10: 'أكتوبر',
                UI_DATE_MONTH_FULL_11: 'نوفمبر',
                UI_DATE_MONTH_FULL_12: 'ديسمبر',

                // 3 Letter or short months
                UI_DATE_MONTH_SHORT_1: 'Jan',
                UI_DATE_MONTH_SHORT_2: 'Feb',
                UI_DATE_MONTH_SHORT_3: 'Mar',
                UI_DATE_MONTH_SHORT_4: 'Apr',
                UI_DATE_MONTH_SHORT_5: 'May',
                UI_DATE_MONTH_SHORT_6: 'Jun',
                UI_DATE_MONTH_SHORT_7: 'Jul',
                UI_DATE_MONTH_SHORT_8: 'Aug',
                UI_DATE_MONTH_SHORT_9: 'Sep',
                UI_DATE_MONTH_SHORT_10: 'Oct',
                UI_DATE_MONTH_SHORT_11: 'Nov',
                UI_DATE_MONTH_SHORT_12: 'Dec'
            },
            hotelInfo: {
                // Accommodation refs

                ACC_HOTEL: 'فندق',
                ACC_MOTEL: 'نُزل',
                ACC_APARTMENT: 'شقة',
                ACC_CHALET: 'شاليه',
                ACC_COTTAGE: 'كوخ',
                ACC_LOG_CABIN: 'تخشيبة',
                ACC_CAMPING_TENT: 'موقع تخييم',
                ACC_CAMPING_SITE: 'موقع تخييم',
                ACC_TEPEE: 'خيمة',
                ACC_RESORT: 'منتجع',
                ACC_BED_N_BREAKFAST: 'سرير وإفطار',
                ACC_APART_HOTEL: 'شقة فندقية',
                ACC_GUEST_HOUSE: 'منزل ضيوف',
                ACC_YOUTH_HOSTEL: 'بيت شباب',
                ACC_BOAT: 'قارب',
                ACC_CAMPER: 'عربة',
                ACC_YURT: 'يورت',
                ACC_TREEHOUSE: 'بيت شجرة',

                ACC_STAR1: 'نجمة واحدة',
                ACC_STAR2: '2 نجوم',
                ACC_STAR3: '3 نجوم',
                ACC_STAR4: '4 نجوم',
                ACC_STAR5: '5 نجوم',
                ACC_NA: 'التقييم غير متاح',
                ACC_BOUTIQUE: 'فندق بوتيك',

                ACC_LUXURIOUS: 'فاخر',
                ACC_UPSCALE: 'راقي',
                ACC_HOMEY: 'منزلي',
                ACC_COSEY: 'كوزي',
                ACC_HIP: 'عصري',
                ACC_FAMILY: 'مناسب للعائلة',
                ACC_CORPORATE: 'شركات'
            }
        },
        errors: {
            'Auth.form.error.invalid': 'بريد الكتروني أو كلمة مرور غير صحيحة',
            'Auth.form.error.email.taken':
                'البريد الإلكتروني أو اسم المستخدم غير متاحين',
            DEFAULTERROR: "حدث خطأ، رجاء التواصل مع الدعم الفني",
            NETWORKERROR: 'مشكلة بالخادم، نأسف على الازعاج',
            LOGIN_SUCCESS: 'أهلاً صانع المحتوى !',
            REGISTER_SUCCESS: 'أهلاً صانع المحتوى !',
            PROFILE_SUCCESS: 'تم حفظ الملف الشخصي',
            FORBIDDEN: "لا توجد لديك صلاحيات كافية",
            REJECTED: 'تم رفض الإدخال',
            NOTFOUND: 'غير متاح الوصول'
        }
    },
};

export default langData;
